import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import { getStatusColors } from '@/ui/components/IssueStatus/utils'
import { TStatus } from '@/ui/components/cases-table/CasesTable.utils'

const STATUS_TO_ISSUE_STATUS: Record<TStatus, TIssueStatus> = {
    waiting: 'open',
    inprogress: 'in_review',
    closed: 'resolved',
    open: 'approved',
}

const getTone = (status: TStatus, theme: TTheme) =>
    getStatusColors(STATUS_TO_ISSUE_STATUS[status], theme)

export const Badge = styled('div')<{ status: TStatus; theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    ${({ status, theme }) => {
        const tone = getTone(status, theme)
        return `
            background-color: ${tone.background};
            color: ${tone.color};
            border: 1px solid ${tone.border};
        `
    }}
`
